import React, { useMemo } from 'react';
import { ProductPromotionTypeRedirect } from '~/features/productList/PLPModule.definitions';
import { useTranslation } from '~/shared/utils/translation';
import { theme } from '~/theme';
import ChevronRight from '~/icons/chevron.svg';

import { useFrame } from '~/shared/utils';
import { Link } from '~/shared/components/Link';
import styles from './campaignRedirecter.module.scss';

type CampaignRedirecter = {
    campaignText?: string;
    campaignType: ProductPromotionTypeRedirect;
    promotionId: string;
};

export const CampaignRedirecter = ({
    campaignText,
    campaignType,
    promotionId,
}: CampaignRedirecter) => {
    const { translate } = useTranslation();
    const { data: frame } = useFrame();
    const campaignRedirectUrls = {
        mixAndMatchPage: frame?.settings?.pageReferences?.mixAndMatchPage?.url,
        bundlePage: frame?.settings?.pageReferences?.bundlePage?.url,
        bastardPage: frame?.settings?.pageReferences?.bastardPage?.url,
    };

    const campaignDetails = useMemo(() => {
        switch (campaignType) {
            case 'mixandmatch':
                return {
                    text: translate('pdp.mixmatchMessage'),
                    url: campaignRedirectUrls.mixAndMatchPage,
                };
            case 'bundle':
                return {
                    text: translate('pdp.bundleMessage'),
                    url: campaignRedirectUrls.bundlePage,
                };
            case 'bastard':
                return {
                    text: translate('pdp.bastardMessage'),
                    url: campaignRedirectUrls.bastardPage,
                };
            default:
                return null;
        }
    }, [campaignType, translate]);

    return (
        <div className={styles.campaignRedirecterContainer}>
            <div className={styles.campaignRedirecterText}>{campaignText}</div>
            <Link
                color={theme.colors.black}
                noHover
                href={`${campaignDetails?.url}?campaign=${encodeURIComponent(promotionId)}`}
            >
                <div className={styles.campaignRedirecterTranslation}>
                    <div className={styles.campaignRedirecterDetails}>{campaignDetails?.text}</div>
                    <ChevronRight />
                </div>
            </Link>
        </div>
    );
};
